/* eslint-disable jira/import-whitelist */
import { checkIsOpsAdmin } from '@jira/eoc__tenant-info/src/controllers/utils.tsx';
import { getTeams } from '@atlassian/eoc-overview/endpoints';
import { getTeamsResource as platformGetTeamsResource } from '@atlassian/eoc-overview/resources';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

import type { TeamsResponse } from '@atlassian/eoc-overview/types';

const ConsolidationState = {
	NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
	TRANSITIONING: 'TRANSITIONING',
	TRANSITIONED: 'TRANSITIONED',
	CONSOLIDATED: 'CONSOLIDATED',
} as const;

type ConsolidationState = (typeof ConsolidationState)[keyof typeof ConsolidationState];

type Cohort = 'cohort1' | 'cohort2' | 'cohort3' | 'cohort3.5' | 'cohort4';

interface TenantInfo {
	consolidationState: ConsolidationState;
	cohortInfo?: Cohort | null;
	isAdmin?: boolean;
}

const CONSOLIDATION_STATE_RESOURCE_TYPE = 'EOC_TENANT';

// eslint-disable-next-line jira/router/no-daisy-chaining-resources
export const getTeamsResource: RouteResource<TeamsResponse | null> = createResource({
	type: platformGetTeamsResource.type,
	getKey: platformGetTeamsResource.getKey,
	getData: async (
		{ dependencies },
		{ tenantContext: { atlassianAccountId, isSiteAdmin, isAdmin } },
	) => {
		if (!atlassianAccountId) {
			return null;
		}
		// oxlint-disable-next-line typescript/consistent-type-assertions
		const tenantInfo = (await dependencies[CONSOLIDATION_STATE_RESOURCE_TYPE]
			?.promise) as TenantInfo;
		const isOpsAdmin = checkIsOpsAdmin(tenantInfo);
		const shouldSeeAllTeams = isSiteAdmin || isAdmin || isOpsAdmin;
		return getTeams({
			queryParams: {
				accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
				showAvatar: true,
				includeTeamExternalDetails: true,
			},
		});
	},
	isBrowserOnly: true,
	maxAge: 0,
	depends: [CONSOLIDATION_STATE_RESOURCE_TYPE],
});
